import React from 'react'
import styles from "./styles/Contribute.module.css"

const Banner = () => {
    return (
        <div className = {styles.banner}>
            <h2>Grab 10% Discount on Clothes. Use coupon code MASAI10</h2>
        </div>
    )
}

export { Banner }
